

class Slide {
    constructor(node) {
        console.log('Slide constructor(node)', node);

        this.node = node;
        this.name = node.dataset.sliderSlide;// node.dataset.name;
        this.progessStep = node.dataset.sliderProgress;

        this.listeners = {};
        this.state;

        console.info('Slide.constructor()', `'${this.name}' is instanciated`);
    }

    getName() {
        console.info('Slide.getName() [this.name]', this.name);
        
        return this.name;
    }

    load() {
        console.info('Slide.load() [this.name]', this.name);

        let result = this.trigger('beforeLoad');

        if (result) {
            this.node.style.display = 'block';
        }

        return result;
    }

    unload() {
        console.info('Slide.unload() [this.name]', this.name);

        let result = this.trigger('beforeUnload');

        if (result) {
            this.node.style.display = 'none';
        }

        return result;
    }

    addEventListener(event, listener) {
        console.info('Slide.addEventListener() [event, listener]', event, listener);

        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }

        this.listeners[event].push(listener);

        return;
    }

    trigger(event) {
        console.info('Slide.trigger() [event]', event);

        let onSuccess = true;

        if (!this.listeners[event]) {
            return onSuccess;
        }

        this.listeners[event].forEach(listener => {
            let result = listener(this);

            if (result === false) {
                onSuccess = false;
            }
        });

        return onSuccess;
    }
}


export default Slide;

